const state = {
  canvasBrother: false,
  currsegment: {},
  dispMarginTop: 0,
  dispMarginLeft: 0,
  patientInputValue: "", // 病例搜索输入框
  patientEditInputValueGroup: {
    // 病例编辑输入框
    firstname: "",
    phone: "",
    pid: "",
    email: "",
    address: ""
  },
  OcInputValue: "", // 眼表输入框
  ErInputValue: "", // 眼红输入框
  ElInputValue: "", // 睑缘输入框
  windowLanguage: "", // 全局语言
  windowNibutModel: 0, // nibut拍摄模式
  windowBUTModel: 0 // BUT拍摄模式
};
const mutations = {};
const actions = {};
export default {
  state,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/dryeye.js